import type { IProps } from "./interfaces"
import classes from "./styles.module.css"

/**
 * Topic chip cloud, reused by the MeetingSummary TopicsCard and the meeting-list
 * cards so the two never drift. Tones rotate across four semantic palettes for
 * visual variety; the same topic at the same index always gets the same tone
 * (stable, no shuffle). Per-chip text colour is derived from the tone via
 * relative-colour syntax so every hue stays legible on its tint (see CSS).
 *
 *   index 0 → brand   1 → info   2 → warning   3 → highlight
 */
const TOPIC_TONES = ["brand", "info", "warning", "highlight"] as const

export const TopicChips = ({ topics, max, size = "md" }: IProps): React.JSX.Element | null => {
  if (!topics || topics.length === 0) return null

  const visible = max != null ? topics.slice(0, max) : topics
  const overflow = max != null ? topics.length - max : 0

  return (
    <div className={classes.cloud} data-size={size}>
      {visible.map((topic, i) => {
        const tone = TOPIC_TONES[i % TOPIC_TONES.length]
        return (
          <span key={`${i}-${topic}`} className={classes.chip} data-tone={tone === "brand" ? undefined : tone}>
            {topic}
          </span>
        )
      })}
      {overflow > 0 && (
        <span className={classes.chip} data-overflow="true">
          +{overflow}
        </span>
      )}
    </div>
  )
}
